import { useSubscription } from '@rta/rta-blueprint-library';

import { Controller } from '@context';
import { lang } from '@lang';
import { useDesign } from '@hooks';
import { Feature, FeatureHoookParams } from '..';

type OverheadDimensionFeatureParams = FeatureHoookParams;
export const useShowOverheadDimensionFeature = (_params: OverheadDimensionFeatureParams = {}): Feature<boolean> => {
	const [controller] = useDesign<Controller, { options: { showOverheadDimensions: boolean }}>();

	useSubscription(controller, false, [['layer-option-overhead-dimension', '*']]);

	const controllerSupportsFeature = (controller?.options?.showOverheadDimensions ?? null) !== null;
	const showLayer = controller?.options?.showOverheadDimensions ?? true;

	const tooltip = (() => {
		const showHide = showLayer ? lang.layer.tooltip.hide : lang.layer.tooltip.show;
		return `${showHide} ${lang.layer.label.overheadDimensions} ${lang.layer.layer}`;
	})();

	return {
		name: 'showOverheadDimensions',
		label: lang.layer.label.overheadDimensions,
		shortcut: '',
		tooltip,
		icon: (props = {}) => <></>,
		disabled: !controllerSupportsFeature,
		value: showLayer,
		hidden: false,
		handler: () => {
			if (controller) {
				controller.options.showOverheadDimensions = !showLayer;
			}
		}
	};
};
